<div class="col-12 col-md-12 mt-2">
  <div class="menu-options">
    <div class="main-title">
      <span class="fa fa-object-group group-icon"></span>&nbsp; Groups
      <!-- [disabled]="!conditionForGroupCreation() || hideGroupCreation" -->
      <button class="btn btn-xs btn-outline-primary pull-right group-creation" type="button"
        title="Groups number quota is reached" (click)="createGroup()">
        <i class="fa fa-plus fa-fw"></i>
      </button>

      <a class="pull-right btn btn-sm" ng-href="">
        <i class="fa fa-question-circle fa-fw"
        title="Groups are created by only admin. They are created to assign particular group of devices to particular group of users"></i>
      </a>
    </div>
    <div class="row mt-5" style="width: 100%;">
      <div class="col-7 col-md-7">
        <app-pagination [totalItems]="groups.length" [itemsPerPage]="groupsPageSize" [itemsSearch]="search"
          (searchedData)="onSearch($event)" (itemPerPageData)="onItemPerPageChange($event)"
          (nextPageChange)="onNextPageChange($event)">
        </app-pagination>
      </div>

      <div class="col-5 col-md-5">
        <button class="btn btn-sm btn-primary-outline pull-right" title="Write an email to the group owner selection"
          (click)="mailToGroupOwners(groups)"
          style="color: blue; --bs-btn-hover-bg: #d3d4d5; margin-left: 1.5vh; --bs-btn-padding-y: 0.15rem;">
          <i class="fa fa-envelope-o"></i>
          <span style="font-size: small;">
            {{"Contact owners" | translate}}
          </span>
        </button>
        <!-- <button class="btn btn-success confirm-remove" title="Enable/Disable confirmation for group removing"
        (click)="confirmRemove.value = !confirmRemove.value"><span *ngIf="confirmRemove.value"
        class="fa fa-lock"></span><span *ngIf="!confirmRemove.value" class="fa fa-unlock"></span>&nbsp; Confirm
      remove</button> -->
      <button class="btn btn-danger remove" title="Remove the group selection"
        (click)="removeGroups(search, filteredGroups, confirmRemove.value, remove_all_devices)"><span
      class="fa fa-regular fa-trash-o"></span>&nbsp; {{"Remove All" | translate}}</button>
    </div>
  </div>
</div>
</div>

<div class="widget-container fluid-height stf-groups">
  <div class="widget-content padded">
    @if (groups.length > 0) {
      <div>
        <ul class="p-0 mt-4">
          <hr>
            @for (group of groups | paginate: { itemsPerPage: groupsPageSize, currentPage: currentPage } | search: search  ; track group; let i = $index) {
              <li class="list-group-item"
                >
                <div class="group-line group-actions">
                  <i class="fa fa-object-group fa-2x fa-fw group-list-icon"></i>
                  <div class="group-list-details selectable">
                    <div class="col-5 col-md-5">
                      @if (group.state === 'pending' && group.isNameClicked) {
                        <div class="form-inline d-flex" name="nameForm"
                          >
                          <input class="form-control input-sm" type="text" placeholder="Name"
                            [(ngModel)]="groupsEnv[group.id].tmpName" [title]="'Regex syntax: ' + nameRegexStr">
                          <button class="btn btn-sm btn-primary btn-check-name" type="button" (click)="updateGroupName(group)"
                            [disabled]="!conditionForNameSaving(group, false)" style="margin-top: 0;">
                            <i class="fa fa-check"></i>
                          </button>
                        </div>
                      }
                    </div>
                    <!-- it is the remove button  -->
                    <div class="float-right">
                      <button class="btn btn-xs option-danger-button pull-right" type="button" (click)="remove(group)"
                        [disabled]="group.privilege === 'root' || group.name == 'ngAsA'">
                        <i class="fa fa-trash-o"></i>&nbsp;
                        <span>{{"Remove" | translate}}</span>
                      </button>
                      @if (group.state === 'pending') {
                        <button class="btn btn-xs option-danger-button pull-right" type="button" id="getReady"
                          (click)="updateGroupState(group)" [hidden]="hiddenGetReady">
                          <i class="fa fa-unlock"></i>&nbsp;
                          <span>{{"Get ready" | translate}}</span>
                        </button>
                      }
                      @if (group.state === 'pending') {
                        <button class="btn btn-xs pull-right" id="nameButton" type="button"
                          (click)="initTemporaryName(group); showName = !showName"
                          [ngClass]="{'option-button-outline': !group.isNameClicked && group.state === 'pending', 'option-button': group.isNameClicked && group.state === 'pending'}">
                          <i class="fa fa-tag"></i>&nbsp;
                          <span>{{"Name" | translate}}</span>
                        </button>
                      }
                      <button class="btn btn-xs pull-right" type="button"
                        (click)="initTemporarySchedule(group); showSchedule = !showSchedule"
                  [ngClass]="{'option-button-outline': !group.isScheduleClicked && group.state === 'pending', 'option-button': group.isScheduleClicked  && group.state === 'pending',
                    'option-warning-outline': !group.isScheduleClicked && !group.isActive && group.state !== 'pending', 'option-warning': group.isScheduleClicked && !group.isActive && group.state !== 'pending',
                    'option-success-outline': !group.isScheduleClicked && group.isActive && group.state !== 'pending', 'option-success': group.isScheduleClicked && group.isActive && group.state !== 'pending'}">
                        <i class="fa fa-clock-o"></i>&nbsp;
                        <span>{{"Schedule"}}</span>
                      </button>
                      <button class="btn btn-xs btn-primary-outline pull-right" type="button"
                        (click)="initShowDevices(group, !showDevices); showDevices = !showDevices"
                        [ngClass]="{'option-button-outline': !group.isDeviceClicked, 'option-button': group.isDeviceClicked}">
                        <i class="fa fa-mobile"></i>&nbsp;
                        <span>{{"Devices" | translate}}</span>
                      </button>
                      <button class="btn btn-xs btn-primary-outline pull-right" type="button"
                        (click)="initShowBrowsers(group); showBrowsers = !showBrowsers"
                        [ngClass]="{'option-button-outline': !group.isBrowserClicked, 'option-button': group.isBrowserClicked}">
                        <i class="fa fa-globe"></i>&nbsp;
                        <span>{{"Browsers" | translate}}</span>
                      </button>
                      <button class="btn btn-xs btn-primary-outline pull-right" type="button"
                        (click)="initShowUsers(group); showUsers = !showUsers"
                        [ngClass]="{'option-button-outline': !group.isUserClicked, 'option-button': group.isUserClicked}">
                        <i class="fa fa-user"></i>&nbsp;
                        <span>{{"Users" | translate}}</span>
                      </button>
                      @if (group.name !== 'Common') {
                        <button class="btn btn-xs btn-primary-outline pull-right" type="button"
                          (click)="initShowDeviceLimit(group);checkDeviceLimit(group.id,group.name); showDeviceLimit = !showDeviceLimit"
                          [ngClass]="{'option-button-outline': !group.isDeviceLimitClicked, 'option-button': group.isDeviceLimitClicked}">
                          <i class="fa fa-fax"></i>&nbsp;
                          <span>{{"Device Limit" | translate }}</span>
                        </button>
                      }
                      @if (groupsEnv[group.id].showConflicts) {
                        <button class="btn btn-xs btn-danger pull-right" type="button"
                          (click)="groupsEnv[group.id].showConflicts = !groupsEnv[group.id].showConflicts"
                          [ngClass]="{'btn-danger-outline': !groupsEnv[group.id].showConflicts, 'btn-danger': groupsEnv[group.id].showConflicts}">
                          <i class="fa fa-ban"></i>&nbsp;
                          <span>{{"Conflicts" | translate}}</span>
                        </button>
                      }
                    </div>
                    @if (group.state !== 'pending' || !showName) {
                      <div class="group-list-name">{{group.name}}</div>
                    }
                    <div class="group-list-id">
                      <span>{{"Identifier:" | translate}} {{group.id}} - </span>
                      <span>{{"Class:"}} {{group.class}} - </span>
                      <span>{{"Devices:" | translate}} {{group.devices.length}} - </span>
                      <span>{{"Users:" | translate}} {{group.users.length}}</span>
                      @if (isAdmin()) {
                        <span> - </span>
                        <span>{{"Owner" | translate}}</span>
                        <span>: {{group.owner.name}}</span>
                      }
                    </div>
                  </div>
                </div>
                <!-- ---------------------------------Conflicts------------------------------------ -->
                @if (groupsEnv[group.id].showConflicts) {
                  <ul class="list-group groups-action">
                    <div ng-include="'settings/groups/conflicts/conflicts.pug'">{{"conflicts" | translate}}</div>
                  </ul>
                }
                <!-- ---------------------------------Device Limit------------------------------------ -->
                @if (group.isDeviceLimitClicked) {
                  <ul class="list-group groups-action">
                    <div class="float-end">
                      <ng-container disabled="group.name === 'Common'" class="list">
                        <span class="text-secondary">{{"Device Limit:" | translate}}</span>
                        <input [disabled]="group.name === 'Common'" style="width:50px" type="number" min=2 [(ngModel)]="dValue"
                          class="inputdevice" id="put">
                        <button value="save" [disabled]="group.name === 'Common'" (click)="setDeviceLimit(group.id,dValue)"
                          class="btn btn-sm" id="save" style="background: #167FFC; color: white; margin-left: 0.5vh;">{{"Update"
                          | translate }}
                        </button>
                      </ng-container>
                    </div>
                  </ul>
                }
                <!-- ---------------------------------Schedule form------------------------------------ -->
                @if (group.isScheduleClicked) {
                  <ul class="list-group groups-action">
                    <div class="heading group-action-body">
                      <i class="fa fa-clock-o"></i>&nbsp; {{"Schedule" | translate}}
                    </div>
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-2 col-md-2">
                            <div class="form-group group-schedule-item">
                              <label class="group-list-label">{{"Class" | translate}}</label>
                              <select [(ngModel)]="groupsEnv[group.id].tmpClass" (change)="watchGroupClass(group,$event)"
                                class="my-dropdown" [disabled]="group.state ==='ready' || disableDropdown">
                                @for (option of classOptions; track option) {
                                  <option value="{{option.id}}">{{option.name}} </option>
                                }
                              </select>
                            </div>
                          </div>
                          <!--
                          <div class="col-md-1" *ngIf="conditionForRepetitions(group)">
                            <div class="form-group group-schedule-item">
                              <label class="group-list-label">Repetitions</label> -->
                              <!-- <input class="form-control input-sm custom-input" type="range" min="0" max="getRepetitionsQuotas(group.owner.email)"
                              ng-model="groupsEnv[group.id].tmpRepetitions" required> -->
                              <!--
                              <span class="group-span-label">{{groupsEnv[group.id].tmpRepetitions}}</span>
                            </div>
                          </div> -->
                          <div class="col-3 col-md-3">
                            <div class="form-group group-schedule-item d-flex">
                              <label class="group-list-label">{{"Starting Date" | translate}}</label>
                              <input class="form-control input-sm custom-input" size="21" type="datetime-local"
                                [(ngModel)]="groupsEnv[group.id].tmpStartDate" placeholder="yyyy-MM-ddTHH:mm:ss:sss"
                                [disabled]="group.state ==='ready'">
                            </div>
                          </div>
                          <div class="col-3 col-md-3">
                            <div class="form-group group-schedule-item d-flex">
                              <label class="group-list-label">{{"Expiration Date" | translate}}</label>
                              <input class="form-control input-sm custom-input" size="21" type="datetime-local"
                                [(ngModel)]="groupsEnv[group.id].tmpStopDate" placeholder="yyyy-MM-ddTHH:mm:ss:sss"
                                [disabled]="group.state ==='ready'">
                            </div>
                          </div>
                          <div class="col-1 col-md-1">
                            <div class="form-group group-schedule-item">
                              <button class="btn option-button" type="button" (click)="updateGroupSchedule(group)"
                                [disabled]="group.state ==='ready' || disableSavebutton">
                                <span>{{"Save" | translate}}</span>
                              </button>
                            </div>
                          </div>
                          <div class="col-2 col-md-2">
                            <div class="form-group group-schedule-item">
                              @if (group.state === 'pending' && conditionForScheduleSaving(group, false) && (groupsEnv[group.id].tmpClass === 'bookable' || groupsEnv[group.id].tmpClass === 'standard')) {
                                <span class="group-span-label-warning"
                                  >
                                  {{"Saving will also get ready the group!" | translate}}
                                </span>
                              }
                              @if (group.state === 'pending' && !conditionForScheduleSaving(group, false) && groupsEnv[group.id].tmpScheduleTooltip !== 'No change') {
                                <span class="group-span-label-error"
                                  >
                                  {{groupsEnv[group.id].tmpScheduleTooltip}}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ul>
                }
                <!-- ---------------------------------Devices table------------------------------------ -->
                @if (group.isDeviceClicked) {
                  <ul class="list-group groups-action">
                    <div class="heading group-action-body">
                      <i class="fa fa-mobile"></i>&nbsp; {{"Devices" | translate}}
                    </div>
                    <div class="row">
                      <div class="panel-group">
                        <div class="panel panel-default">
                          <div class="panel-heading text-center">
                            <div class="alert alert-dark custom-alert mb-0" role="alert">
                              <button class="btn btn-xs btn-group-devices-action" type="button"
                                (click)="groupDevices(group);this.showGroupDevices = !this.showGroupDevices;"
                                [ngClass]="{'option-button-outline': !showGroupDevices, 'option-button': showGroupDevices}">
                                <i class="fa fa-mobile"></i>&nbsp;{{"Group devices" | translate}}
                              </button>
                            </div>
                          </div>
                          @if (showGroupDevices) {
                            <div class="panel-body">
                              <div class="row">
                                <div style="width: fit-content;">
                                  <app-pagination [totalItems]="groupstandardizableDevicesList.length"
                                    [itemsPerPage]="groupDevicePageSize" [itemsSearch]="deviceSearch"
                                    (searchedData)="onDeviceSearch($event)" (itemPerPageData)="onDeviceItemPerPageChange($event)"
                                    (nextPageChange)="onNextDevicePageChange($event)">
                                  </app-pagination>
                                </div>
                                <div class="pull-left" style="width: fit-content;">
                                  <button class="btn btn-xs btn-primary-outline co-btn" type="button"
                                    style="--bs-btn-hover-bg: #d3d4d5;" (click)="showGrpmenu();">
                                    <i class="fa fa-columns"></i><span>&nbsp;{{"Customize" | translate}}</span>
                                  </button>
                                  @if (this.showGrpMenu) {
                                    <ul class="dropdown-menu pointer protean-column-customize" role="menu"
                                      (click)="$event.stopPropagation()">
                                      @for (column of defaultDeviceData.columns; track column) {
                                        <li>
                                          <label class="checkbox pointer">
                                            <input type="checkbox" [(ngModel)]="column.selected" /><span
                                          class="checkbox-label">{{column.name}}</span>
                                        </label>
                                      </li>
                                    }
                                    <li>
                                      <button class="btn btn-outline-danger btn-sm border-0 checkbox" (click)="resetData()"><i
                                        class="fa fa-trash-o"></i><span>&nbsp;{{"Reset" | translate}}</span></button>
                                      </li>
                                    </ul>
                                  }
                                </div>
                              </div>
                              @if (groupstandardizableDevicesList.length > 0) {
                                <div>
                                  <div class="widget-container fluid-height overflow-auto">
                                    <div class="table-container">
                                      <table class="table table-hover table-responsive">
                                        <thead>
                                          <tr>
                                            <th class="header">
                                              <button type="button" (click)="removeGroupDevices(group)"
                                                class="btn btn-sm btn-danger btn-group-users-action">
                                                <i class="fa fa-trash-o"></i>
                                              </button>
                                            </th>
                                            <!-- grp devices -->
                                            @for (column of defaultDeviceData.columns; track column) {
                                              <th class="header sortable" ng-class="[column.sort]"
                                                (click)="sortByGroupDevices(defaultDeviceData, column)">
                                                <div class="strong">
                                                  @if (column.selected) {
                                                    <span
                                                      [ngClass]="{'sort-both': column.sort === 'none' || defaultDeviceData.sort.class === 'avl','sort-asc': column.sort === 'sort-asc' && defaultDeviceData.sort.class === 'grp', 'sort-desc': column.sort === 'sort-desc' && defaultDeviceData.sort.class === 'grp'}">
                                                      {{column.name}}
                                                    </span>
                                                  }
                                                </div>
                                              </th>
                                            }
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <!-- sort:deviceColumns[defaultDeviceData.sort.index]:defaultDeviceData.sort.reverse -->
                                          <!-- groupDevices -->
                                          @for (device of groupstandardizableDevicesList | paginate: { itemsPerPage: groupDevicePageSize, currentPage: deviceCurrentPage } | search: deviceSearch | sort: sortFieldGrpDevices:sortDirectionGrpDevices; track device) {
                                            <tr class="selectable"
                                              >
                                              <td>
                                                <button class="btn btn-danger-outline btn-xs" [disabled]="group.privilege === 'root'"
                                                  (click)="removeGroupDevice(group, device)">
                                                  <i class="fa fa-trash-o fa-fw"></i>
                                                </button>
                                              </td>
                                              @for (column of defaultDeviceData.columns; track column) {
                                                <td>
                                                  @if (column.selected) {
                                                    @switch (column.name) {
                                                      @case ('Model') {
                                                        <td>{{device.model}}</td>
                                                      }
                                                      @case ('Serial') {
                                                        <td>{{device.serial}}</td>
                                                      }
                                                      @case ('Carrier') {
                                                        <td>{{device.operator}}</td>
                                                      }
                                                      @case ('OS') {
                                                        <td>{{device.version}}</td>
                                                      }
                                                      @case ('Network') {
                                                        <td>{{device.networkStr}}</td>
                                                      }
                                                      @case ('Screen') {
                                                        <td>{{device.displayStr}}</td>
                                                      }
                                                      @case ('Manufacturer') {
                                                        <td>{{device.manufacturer}}</td>
                                                      }
                                                      @case ('SDK') {
                                                        <td>{{device.sdk}}</td>
                                                      }
                                                      @case ('ABI') {
                                                        <td>{{device.abi}}</td>
                                                      }
                                                      @case ('CPU Platform') {
                                                        <td>{{device.cpuPlatform}}</td>
                                                      }
                                                      @case ('OpenGL ES version') {
                                                        <td>{{device.openGLESVersion}}</td>
                                                      }
                                                      @case ('Market name') {
                                                        <td>{{device.marketName}}</td>
                                                      }
                                                      @case ('Phone IMEI') {
                                                        <td>{{device.phone.imei}}</td>
                                                      }
                                                      @case ('Location') {
                                                        <td>{{device.provider.name}}</td>
                                                      }
                                                      @case ('Group Origin') {
                                                        <td>{{device.group.originName}}</td>
                                                      }
                                                    }
                                                  }
                                                </td>
                                              }
                                            </tr>
                                          }
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                        <div class="panel panel-default">
                          <div class="panel-heading text-center">
                            <div class="alert alert-dark custom-alert mb-0 mt-1" role="alert">
                              <button class="btn btn-xs btn-group-devices-action" type="button"
                                (click)="groupAvailabeDevices(group);showAvailableDevices = !showAvailableDevices"
                                [ngClass]="{'option-button-outline': !showAvailableDevices, 'option-button': showAvailableDevices}">
                                <i class="fa fa-mobile"></i>&nbsp; {{"Available devices" | translate}}
                              </button>
                            </div>
                          </div>
                          @if (showAvailableDevices) {
                            <div class="panel-body">
                              <div class="row">
                                <div style="width: fit-content;">
                                  <app-pagination [totalItems]="groupAvailablestandardizableDevicesList.length"
                                    [itemsPerPage]="availableDevicePageSize" [itemsSearch]="availableDeviceSearch"
                                    (searchedData)="onAvailableDeviceSearch($event)"
                                    (itemPerPageData)="onAvailableDeviceItemPerPageChange($event)"
                                    (nextPageChange)="onNextAvailableDevicePageChange($event)">
                                  </app-pagination>
                                </div>
                                <div class="pull-left" style="width: fit-content;">
                                  <button class="btn btn-xs btn-primary-outline co-btn" style="--bs-btn-hover-bg: #d3d4d5;"
                                    type="button" (click)="showAvlmenu();">
                                    <i class="fa fa-columns"></i><span>&nbsp;{{"Customize" | translate}}</span>
                                  </button>
                                  @if (this.showAvlMenu) {
                                    <ul class="dropdown-menu pointer protean-column-customize" role="menu"
                                      (click)="$event.stopPropagation()">
                                      @for (column of defaultDeviceData.columns; track column) {
                                        <li>
                                          <label class="checkbox pointer">
                                            <input type="checkbox" [(ngModel)]="column.selected" /><span
                                          class="checkbox-label">{{column.name}}</span>
                                        </label>
                                      </li>
                                    }
                                    <li>
                                      <button class="btn btn-outline-danger btn-sm border-0 checkbox" (click)="resetData()"><i
                                        class="fa fa-trash-o"></i><span>&nbsp;{{"Reset" | translate}}</span></button>
                                      </li>
                                    </ul>
                                  }
                                </div>
                              </div>
                              <div class="widget-container fluid-height overflow-auto">
                                <table class="table table-hover dataTable ng-table">
                                  <thead>
                                    <tr>
                                      <th class="header">
                                        <button class="btn btn-sm btn-primary btn-group-devices-action" type="button"
                                          ng-if="groupsEnv[filteredGroups[getGroupIndex($parent.$index)].id].hasOwnProperty('filteredAvailableDevices')"
                                          (click)="addGroupDevices(group)">
                                          <i class="fa fa-cart-plus"></i>
                                        </button>
                                      </th>
                                      @for (column of deviceData.columns; track column) {
                                        <th class="header sortable" ng-class="[column.sort]"
                                          (click)="sortByAvailableDevices(deviceData, column)">
                                          <div class="strong">
                                            @if (column.selected) {
                                              <span
                                                [ngClass]="{'sort-both-avl': column.sort === 'none' || defaultDeviceData.sort.class === 'grp','sort-asc-avl': column.sort === 'sort-asc' && defaultDeviceData.sort.class === 'avl', 'sort-desc-avl': column.sort === 'sort-desc' && defaultDeviceData.sort.class === 'avl'}">
                                                {{column.name}}
                                              </span>
                                            }
                                          </div>
                                        </th>
                                      }
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <!-- | sort:sortFieldAvlDevices:sortDirectionAvlDevices  -->
                                    <!-- avl devices -->
                                    @for (device of groupAvailablestandardizableDevicesList | paginate: { itemsPerPage: availableDevicePageSize, currentPage: availableDeviceCurrentPage } | search: availableDeviceSearch | sort:sortFieldAvlDevices:sortDirectionAvlDevices; track device) {
                                      <tr class="selectable"
                                        >
                                        <td>
                                          <button class="btn btn-primary-outline btn-xs" type="button"
                                            (click)="addGroupDevice(group, device)">
                                            <i class="fa fa-cart-plus fa-fw"></i>
                                          </button>
                                        </td>
                                        @for (column of deviceData.columns; track column) {
                                          <td>
                                            @if (column.selected) {
                                              @switch (column.name) {
                                                @case ('Model') {
                                                  <td>{{device.model}}</td>
                                                }
                                                @case ('Serial') {
                                                  <td>{{device.serial}}</td>
                                                }
                                                @case ('Carrier') {
                                                  <td>{{device.operator}}</td>
                                                }
                                                @case ('OS') {
                                                  <td>{{device.version}}</td>
                                                }
                                                @case ('Network') {
                                                  <td>{{device.networkStr}}</td>
                                                }
                                                @case ('Screen') {
                                                  <td>{{device.displayStr}}</td>
                                                }
                                                @case ('Manufacturer') {
                                                  <td>{{device.manufacturer}}</td>
                                                }
                                                @case ('SDK') {
                                                  <td>{{device.sdk}}</td>
                                                }
                                                @case ('ABI') {
                                                  <td>{{device.abi}}</td>
                                                }
                                                @case ('CPU Platform') {
                                                  <td>{{device.cpuPlatform}}</td>
                                                }
                                                @case ('OpenGL ES version') {
                                                  <td>{{device.openGLESVersion}}</td>
                                                }
                                                @case ('Market name') {
                                                  <td>{{device.marketName}}</td>
                                                }
                                                @case ('Phone IMEI') {
                                                  <td>{{device.phone.imei}}</td>
                                                }
                                                @case ('Location') {
                                                  <td>{{device.provider.name}}</td>
                                                }
                                                @case ('Group Origin') {
                                                  <td>{{device.group.originName}}</td>
                                                }
                                              }
                                            }
                                          </td>
                                        }
                                      </tr>
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </ul>
                }
                @if (group.isBrowserClicked) {
                  <ul class="list-group groups-action">
                    <div class="heading group-action-body">
                      <i class="fa fa-globe"></i>&nbsp; {{"Browsers" | translate}}
                    </div>
                    <div class="row">
                      <div class="panel-group">
                        <!-- Group Browsers Panel -->
                        <div class="panel panel-default">
                          <div class="panel-heading text-center">
                            <div class="alert alert-dark custom-alert mb-0" role="alert">
                              <button class="btn btn-xs btn-group-devices-action" type="button"
                                (click)="groupBrowsers(group); getGroupState(group.id).showGroupBrowsers = !getGroupState(group.id).showGroupBrowsers;"
                                [ngClass]="{'option-button-outline': !getGroupState(group.id).showGroupBrowsers, 'option-button': getGroupState(group.id).showGroupBrowsers}">
                                <i class="fa fa-globe"></i>&nbsp;{{"Group browsers" | translate}}
                              </button>
                            </div>
                          </div>
                          @if (getGroupState(group.id).showGroupBrowsers) {
                            <div class="panel-body">
                              <div class="row">
                                <div style="width: fit-content;">
                                  <app-pagination [totalItems]="getGroupState(group.id).groupBrowsers.length"
                                    [itemsPerPage]="getGroupState(group.id).groupBrowserPageSize"
                                    [itemsSearch]="getGroupState(group.id).browserSearch"
                                    (searchedData)="onBrowserSearch(group, $event)"
                                    (itemPerPageData)="onBrowserItemPerPageChange(group, $event)"
                                    (nextPageChange)="onNextBrowserPageChange(group, $event)">
                                  </app-pagination>
                                </div>
                                <div class="pull-left" style="width: fit-content;">
                                  <button class="btn btn-xs btn-primary-outline co-btn" type="button"
                                    style="--bs-btn-hover-bg: #d3d4d5;" (click)="showBrowserGrpmenu(group);">
                                    <i class="fa fa-columns"></i><span>&nbsp;{{"Customize" | translate}}</span>
                                  </button>
                                  @if (getGroupState(group.id).showBrowserGrpMenu) {
                                    <ul class="dropdown-menu pointer protean-column-customize"
                                      role="menu"
                                      (click)="$event.stopPropagation()">
                                      @for (column of defaultBrowserData.columns; track column) {
                                        <li>
                                          <label class="pointer">
                                            <span class="column-label">{{column.name}}</span>
                                          </label>
                                        </li>
                                      }
                                      <li>
                                        <button class="btn btn-outline-danger btn-sm border-0" (click)="resetBrowserData()">
                                          <i class="fa fa-trash-o"></i><span>&nbsp;{{"Reset" | translate}}</span>
                                        </button>
                                      </li>
                                    </ul>
                                  }
                                </div>
                              </div>
                              @if (getGroupState(group.id).groupBrowsers.length > 0) {
                                <div>
                                  <div class="widget-container fluid-height overflow-auto">
                                    <div class="table-container">
                                      <table class="table table-hover table-responsive">
                                        <thead>
                                          <tr>
                                            <th class="header text-center">
                                              <button type="button" (click)="removeGroupBrowsers(group)"
                                                class="btn btn-sm btn-danger btn-group-users-action ml-2">
                                                <i class="fa fa-trash-o"></i>
                                              </button>
                                            </th>
                                            @for (column of defaultBrowserData.columns; track column) {
                                              <th class="header sortable text-center"
                                                (click)="sortByGroupBrowsers(group, defaultBrowserData, column)">
                                                <div class="strong">
                                                  @if (column.selected) {
                                                    <span
                                      [ngClass]="{'sort-both': column.sort === 'none' || defaultBrowserData.sort.class === 'avl',
                                       'sort-asc': column.sort === 'sort-asc' && defaultBrowserData.sort.class === 'grp', 
                                       'sort-desc': column.sort === 'sort-desc' && defaultBrowserData.sort.class === 'grp'}">
                                                      {{column.name}}
                                                    </span>
                                                  }
                                                </div>
                                              </th>
                                            }
                                          </tr>
                                        </thead>
                                        <tbody>
                                          @for (browser of getGroupState(group.id).groupBrowsers |
                                            paginate: { itemsPerPage: getGroupState(group.id).groupBrowserPageSize,
                                            currentPage: getGroupState(group.id).browserCurrentPage } |
                                            search: getGroupState(group.id).browserSearch |
                                            sort: getGroupState(group.id).sortFieldGrpBrowsers:getGroupState(group.id).sortDirectionGrpBrowsers; track browser) {
                                            <tr class="selectable"
                                              >
                                              <td class="text-center">
                                                <button class="btn btn-danger-outline btn-xs" [disabled]="group.privilege === 'root'"
                                                  (click)="removeGroupBrowser(group, browser)">
                                                  <i class="fa fa-trash-o fa-fw"></i>
                                                </button>
                                              </td>
                                              @for (column of defaultBrowserData.columns; track column) {
                                                <td class="text-center">
                                                  @if (column.selected) {
                                                    @switch (column.name) {
                                                      @case ('ID') {
                                                        <span>{{browser.id}}</span>
                                                      }
                                                      @case ('Browser') {
                                                        <span>
                                                          {{browser.browser}}
                                                        </span>
                                                      }
                                                      @case ('Browser Version') {
                                                        <span>{{browser.browserVersion}}</span>
                                                      }
                                                      @case ('OS') {
                                                        <span>
                                                          {{browser.os}}
                                                        </span>
                                                      }
                                                      @case ('IP') {
                                                        <span>{{browser.ip}}</span>
                                                      }
                                                      @case ('Port') {
                                                        <span>{{browser.port}}</span>
                                                      }
                                                      @case ('Username') {
                                                        <span>{{browser.username}}</span>
                                                      }
                                                      @case ('Access URL') {
                                                        <span>
                                                          <a href="{{browser.accessUrl}}" target="_blank" class="btn btn-xs btn-link">
                                                            <i class="fa fa-external-link"></i> Access
                                                          </a>
                                                        </span>
                                                      }
                                                      @case ('Automation URL') {
                                                        <span>
                                                          <a href="{{browser.automationUrl}}" target="_blank" class="btn btn-xs btn-link">
                                                            <i class="fa fa-external-link"></i> Automation
                                                          </a>
                                                        </span>
                                                      }
                                                      @case ('Automation Port') {
                                                        <span>{{browser.automationPort}}</span>
                                                      }
                                                      @case ('NGASA URL') {
                                                        <span>
                                                          <a href="{{browser.ngasa_url}}" target="_blank" class="btn btn-xs btn-link">
                                                            <i class="fa fa-external-link"></i> NGASA
                                                          </a>
                                                        </span>
                                                      }
                                                    }
                                                  }
                                                </td>
                                              }
                                            </tr>
                                          }
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                        <!-- Available Browsers Panel -->
                        <div class="panel panel-default">
                          <div class="panel-heading text-center">
                            <div class="alert alert-dark custom-alert mb-0 mt-1" role="alert">
                              <button class="btn btn-xs btn-group-devices-action" type="button"
                                (click)="groupAvailableBrowsers(group); getGroupState(group.id).showAvailableBrowsers = !getGroupState(group.id).showAvailableBrowsers"
                        [ngClass]="{'option-button-outline': !getGroupState(group.id).showAvailableBrowsers, 
                         'option-button': getGroupState(group.id).showAvailableBrowsers}">
                                <i class="fa fa-globe"></i>&nbsp; {{"Available browsers" | translate}}
                              </button>
                            </div>
                          </div>
                          @if (getGroupState(group.id).showAvailableBrowsers) {
                            <div class="panel-body">
                              <div class="row">
                                <div style="width: fit-content;">
                                  <app-pagination [totalItems]="getGroupState(group.id).availableBrowsers.length"
                                    [itemsPerPage]="getGroupState(group.id).availableBrowserPageSize"
                                    [itemsSearch]="getGroupState(group.id).availableBrowserSearch"
                                    (searchedData)="onAvailableBrowserSearch(group, $event)"
                                    (itemPerPageData)="onAvailableBrowserItemPerPageChange(group, $event)"
                                    (nextPageChange)="onNextAvailableBrowserPageChange(group, $event)">
                                  </app-pagination>
                                </div>
                                <div class="pull-left" style="width: fit-content;">
                                  <button class="btn btn-xs btn-primary-outline co-btn" style="--bs-btn-hover-bg: #d3d4d5;"
                                    type="button" (click)="showBrowserAvlmenu(group);">
                                    <i class="fa fa-columns"></i><span>&nbsp;{{"Customize" | translate}}</span>
                                  </button>
                                  @if (getGroupState(group.id).showBrowserAvlMenu) {
                                    <ul class="dropdown-menu pointer protean-column-customize"
                                      role="menu"
                                      (click)="$event.stopPropagation()">
                                      @for (column of browserData.columns; track column) {
                                        <li>
                                          <label class="pointer">
                                            <span class="column-label">{{column.name}}</span>
                                          </label>
                                        </li>
                                      }
                                      <li>
                                        <button class="btn btn-outline-danger btn-sm border-0" (click)="resetBrowserData()">
                                          <i class="fa fa-trash-o"></i><span>&nbsp;{{"Reset" | translate}}</span>
                                        </button>
                                      </li>
                                    </ul>
                                  }
                                </div>
                              </div>
                              <div class="widget-container fluid-height overflow-auto">
                                <table class="table table-hover dataTable ng-table">
                                  <thead>
                                    <tr>
                                      <th class="header text-center">
                                        <button class="btn btn-sm btn-primary btn-group-devices-action ml-2" type="button"
                                          (click)="addGroupBrowsers(group)">
                                          <i class="fa fa-cart-plus"></i>
                                        </button>
                                      </th>
                                      @for (column of browserData.columns; track column) {
                                        <th class="header sortable text-center"
                                          (click)="sortByAvailableBrowsers(group, browserData, column)">
                                          <div class="strong">
                                            @if (column.selected) {
                                              <span
                                  [ngClass]="{'sort-both-avl': column.sort === 'none' || defaultBrowserData.sort.class === 'grp',
                                   'sort-asc-avl': column.sort === 'sort-asc' && defaultBrowserData.sort.class === 'avl', 
                                   'sort-desc-avl': column.sort === 'sort-desc' && defaultBrowserData.sort.class === 'avl'}">
                                                {{column.name}}
                                              </span>
                                            }
                                          </div>
                                        </th>
                                      }
                                    </tr>
                                  </thead>
                                  <tbody>
                                    @for (browser of getGroupState(group.id).availableBrowsers |
                                      paginate: { itemsPerPage: getGroupState(group.id).availableBrowserPageSize,
                                      currentPage: getGroupState(group.id).availableBrowserCurrentPage } |
                                      search: getGroupState(group.id).availableBrowserSearch |
                                      sort: getGroupState(group.id).sortFieldAvlBrowsers:getGroupState(group.id).sortDirectionAvlBrowsers; track browser) {
                                      <tr class="selectable"
                                        >
                                        <td class="text-center">
                                          <button class="btn btn-primary-outline btn-xs" type="button"
                                            (click)="addGroupBrowser(group, browser)">
                                            <i class="fa fa-cart-plus fa-fw"></i>
                                          </button>
                                        </td>
                                        @for (column of browserData.columns; track column) {
                                          <td class="text-center">
                                            @if (column.selected) {
                                              @switch (column.name) {
                                                @case ('ID') {
                                                  <span>{{browser.id}}</span>
                                                }
                                                @case ('Browser') {
                                                  <span>
                                                    {{browser.browser}}
                                                  </span>
                                                }
                                                @case ('Browser Version') {
                                                  <span>{{browser.browserVersion}}</span>
                                                }
                                                @case ('OS') {
                                                  <span>
                                                    {{browser.os}}
                                                  </span>
                                                }
                                                @case ('IP') {
                                                  <span>{{browser.ip}}</span>
                                                }
                                                @case ('Port') {
                                                  <span>{{browser.port}}</span>
                                                }
                                                @case ('Username') {
                                                  <span>{{browser.username}}</span>
                                                }
                                                @case ('Access URL') {
                                                  <span>
                                                    <a href="{{browser.accessUrl}}" target="_blank" class="btn btn-xs btn-link">
                                                      <i class="fa fa-external-link"></i> Access
                                                    </a>
                                                  </span>
                                                }
                                                @case ('Automation URL') {
                                                  <span>
                                                    <a href="{{browser.automationUrl}}" target="_blank" class="btn btn-xs btn-link">
                                                      <i class="fa fa-external-link"></i> Automation
                                                    </a>
                                                  </span>
                                                }
                                                @case ('Automation Port') {
                                                  <span>{{browser.automationPort}}</span>
                                                }
                                                @case ('NGASA URL') {
                                                  <span>
                                                    <a href="{{browser.ngasa_url}}" target="_blank" class="btn btn-xs btn-link">
                                                      <i class="fa fa-external-link"></i> NGASA
                                                    </a>
                                                  </span>
                                                }
                                              }
                                            }
                                          </td>
                                        }
                                      </tr>
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </ul>
                }
                <!-- ---------------------------------User table------------------------------------ -->
                @if (group.isUserClicked) {
                  <ul class="list-group groups-action">
                    <div class="heading group-action-body">
                      <i class="fa fa-user"></i>&nbsp; {{"Users" | translate}}
                    </div>
                    <div class="row">
                      <div class="panel-group">
                        <div class="panel panel-default">
                          <div class="panel-heading text-center">
                            <div class="alert alert-dark custom-alert mb-0" role="alert">
                              <button type="button" (click)="groupUser(group); showGroupUsers = !showGroupUsers"
                                [ngClass]="{'option-button-outline': !showGroupUsers, 'option-button': showGroupUsers}"
                                class="btn btn-xs btn-group-users-action btn-primary-outline">
                                <i class="fa fa-user"></i>&nbsp; {{"Group users" | translate}}
                              </button>
                            </div>
                          </div>
                          @if (showGroupUsers) {
                            <div class="mb-1">
                              <div class="card">
                                <div class="col-7 col-md-7 m-2">
                                  <app-pagination [totalItems]="groupUserList.length" [itemsPerPage]="groupsUserPageSize"
                                    [itemsSearch]="userSearch" (searchedData)="onUserSearch($event)"
                                    (itemPerPageData)="onUserItemPerPageChange($event)"
                                    (nextPageChange)="onNextUserPageChange($event)">
                                  </app-pagination>
                                </div>
                                <div class="row m-3">
                                  <div class="col-12 col-md-12">
                                    <div style="font-size: 30px;">
                                      <table id="groupTable" class="table table-hover table-responsive">
                                        <thead class="thead-light">
                                          @if (groupUserList.length == 0) {
                                            <tr>
                                              <div class="d-flex align-item-center justify-content-center text-secondary">
                                                <i class="fa fa-3x fa-user"></i>
                                              </div>
                                              <p class="text-center text-secondary">{{"No available users" | translate}}</p>
                                            </tr>
                                          }
                                          @if (groupUserList.length != 0) {
                                            <tr>
                                              <th class="header sortable"><span class="strong">
                                                <button type="button" (click)="removeGroupUsers(group)"
                                                  class="btn btn-sm btn-danger btn-group-users-action"><i
                                                class="fa fa-trash-o"></i>
                                              </button>
                                            </span>
                                          </th>
                                          <th
                                            [ngClass]="{'sort-asc':this.currentColumn=='name' && this.sortOrder=='asc','sort-desc':this.currentColumn=='name' && this.sortOrder=='desc','sort-both': currentColumn !== 'name' || sortOrder === ''}"
                                            class="header sortable" (click)="onColumnClick('name')"><span
                                          class="strong">{{"Name" | translate}}</span></th>
                                          <th
                                            [ngClass]="{'sort-asc':this.currentColumn=='email' && this.sortOrder=='asc','sort-desc':this.currentColumn=='email' && this.sortOrder=='desc','sort-both': currentColumn !== 'email' || sortOrder === ''}"
                                            class="header sortable" (click)="onColumnClick('email')"><span
                                          class="strong">{{"Email" | translate}}</span></th>
                                          <th
                                            [ngClass]="{'sort-asc':this.currentColumn=='privilege' && this.sortOrder=='asc','sort-desc':this.currentColumn=='privilege' && this.sortOrder=='desc','sort-both': currentColumn !== 'privilege' || sortOrder === ''}"
                                            class="header sortable" (click)="onColumnClick('privilege')"><span
                                          class="strong">{{"Privilege" | translate}}</span></th>
                                        </tr>
                                      }
                                    </thead>
                                    <tbody>
                                      @for (user of groupUserList | paginate: { itemsPerPage: groupsUserPageSize, currentPage: userCurrentPage } | search: userSearch; track user; let i = $index) {
                                        <tr
                                          >
                                          <td>
                                            <button type="button" [disabled]="user.privilege === 'admin'"
                                              (click)="removeGroupUser(group, user)"
                                              class="btn btn-sm btn-outine-danger btn-group-users-action">
                                              <i class="fa fa-trash-o fa-fw"></i>
                                            </button>
                                          </td>
                                          <td>{{user.name}}</td>
                                          <td>{{user.email}}</td>
                                          <td>{{user.privilege}}</td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="panel panel-default">
                      <div class="panel-heading text-center">
                        <div class="alert alert-dark custom-alert mb-0 mt-1" role="alert">
                          <button type="button" (click)="availableUser(group);showAvailableUsers = !showAvailableUsers"
                            [ngClass]="{'option-button-outline': !showAvailableUsers, 'option-button': showAvailableUsers}"
                            class="btn btn-xs btn-group-users-action btn-primary-outline">
                            <i class="fa fa-user"></i>&nbsp; {{"Available users" | translate}}
                          </button>
                        </div>
                      </div>
                      @if (showAvailableUsers) {
                        <div class="mb-1">
                          <div class="card">
                            <div class="col-7 col-md-7 m-2">
                              <app-pagination [totalItems]="availableUserList.length" [itemsPerPage]="availableUserPageSize"
                                [itemsSearch]="availableUserSearch" (searchedData)="onAvailableUserSearch($event)"
                                (itemPerPageData)="onAvailableUserItemPerPageChange($event)"
                                (nextPageChange)="onNextAvailableUserPageChange($event)">
                              </app-pagination>
                            </div>
                            <div class="row m-3">
                              <div class="col-12 col-md-12">
                                <div style="font-size: 30px;">
                                  <table id="groupTable" class="table table-hover table-responsive">
                                    <thead class="thead-light">
                                      @if (availableUserList.length == 0) {
                                        <tr>
                                          <div class="d-flex align-item-center justify-content-center text-secondary">
                                            <i class="fa fa-3x fa-user"></i>
                                          </div>
                                          <p class="text-center text-secondary">{{"No available users" | translate}}</p>
                                        </tr>
                                      }
                                      @if (availableUserList.length != 0) {
                                        <tr>
                                          <th class="header sortable">
                                            <button type="button" (click)="addGroupUsers(group)"
                                              class="btn btn-sm option-button btn-group-users-action ng-scope"><i
                                            class="fa fa-cart-plus"></i></button>
                                          </th>
                                          <th
                                            [ngClass]="{'sort-asc':this.currentColumn=='name' && this.sortOrder=='asc','sort-desc':this.currentColumn=='name' && this.sortOrder=='desc','sort-both': currentColumn !== 'name' || sortOrder === ''}"
                                            class="header sortable" (click)="onColumnClickAvlUsers('name')"><span
                                          class="strong">{{"Name" | translate}}</span></th>
                                          <th
                                            [ngClass]="{'sort-asc':this.currentColumn=='email' && this.sortOrder=='asc','sort-desc':this.currentColumn=='email' && this.sortOrder=='desc','sort-both': currentColumn !== 'email' || sortOrder === ''}"
                                            class="header sortable" (click)="onColumnClickAvlUsers('email')"><span
                                          class="strong">{{"Email" | translate}}</span></th>
                                          <th
                                            [ngClass]="{'sort-asc':this.currentColumn=='privilege' && this.sortOrder=='asc','sort-desc':this.currentColumn=='privilege' && this.sortOrder=='desc','sort-both': currentColumn !== 'privilege' || sortOrder === ''}"
                                            class="header sortable" (click)="onColumnClickAvlUsers('privilege')"><span
                                          class="strong">{{"Privilege" | translate}}</span></th>
                                        </tr>
                                      }
                                    </thead>
                                    <tbody>
                                      @for (user of availableUserList | paginate: { itemsPerPage: availableUserPageSize, currentPage: availableUserCurrentPage } | search: availableUserSearch ; track user; let i = $index) {
                                        <tr
                                          >
                                          <td>
                                            <button type="button" (click)="addGroupUser(group, user)"
                                              class="btn option-button-outline btn-xs">
                                              <i class="fa fa-cart-plus fa-fw"></i>
                                            </button>
                                          </td>
                                          <td>{{user.name}}</td>
                                          <td>{{user.email}}</td>
                                          <td>{{user.privilege}}</td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </ul>
            }
            <hr>
            </li>
          }
        </ul>
      </div>
    }
  </div>
</div>



<!-- Template -->
<ng-template #alert_message let-modal>
  <div class="modal-body text-center">
    <p class="action-message">{{alertMessage | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-primary" (click)="cancelRequest()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #remove_group let-modal>
  <div class="modal-body text-center">
    <p class="action-message">{{"Delete this group for sure?" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="removeGroup()">{{"Yes, Proceed" | translate}}</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #remove_all_devices let-modal>
  <div class="modal-body text-center">
    <p class="action-message">{{"Are you sure you want to delete All groups?" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="removeGroups();">{{"Yes, Proceed" |
      translate}}</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>